import React,{useEffect, useState} from 'react';

import project1 from "../../Images/blog1.png";
import project2 from "../../Images/blog2.png";
import project3 from "../../Images/blog3.png";
import project4 from "../../Images/blog4.png";

export default function Work(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);

        return () =>window.removeEventListener("scroll", handleScroll);
    },[])

    return(
        <div className="Work Product">
            <div className="work-intro" data-aos="fade-right">
                <h2 className="work-Title">Latest articles on design, development and experience.</h2>
                <p className="work-slogan">Level up your development skills and learn about interactive projects, ideas and a lot more.</p>
            </div>
            {media.matches && (
                <div>
            <div className="portfolio">
                <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-neumorphism-ui-ux-design-1ffaf46226f0">
                <div className="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project1} className="blogimg" />
                    </div>
                    <div className="project-des blog-des" >
                        <div>
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Neumorphism UI/UX Design.</h3>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">8K+</div>
                    </div>
                </div>
                </a>
                <a href="https://uxplanet.org/my-portfolio-website-helps-me-to-get-a-full-stack-internship-32c2f70d8a8f">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project2} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">My Portfolio Website Helps Me To Get A Full Stack Internship.</h3>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="portfolio sec-port">
                <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-glassmorphism-ui-ux-design-848599c74094">
                <div className="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project3} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Glassmorphism UI/UX Design.</h3>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
                </a>
                <a href="https://uxplanet.org/5-best-landing-pages-that-anyone-can-create-254ce1f9c91c">
                <div Class="project-div blog-div"  data-aos="fade-up">
                    <div className="project-img blog-img">
                        <img src={project4} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                            <h3 className="des-head blog-head">5 Best Landing Pages that Anyone Can Create.</h3>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">2K+</div>
                    </div>
                </div>
                </a>
            </div>
            <div className="social-footer" data-aos="fade-up">
                <a href="https://medium.com/@vikalpkaushik99"><button className="social-btn">More Blogs 📝</button></a>
            </div>
            </div>
            )}
            {!media.matches && (
                <div>
            <div className="portfolio">
               
                <div className="project-div blog-div">
                    <div className="project-img blog-img">
                        <img src={project1} className="blogimg" />
                    </div>
                    <div className="project-des blog-des" >
                        <div>
                            <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-neumorphism-ui-ux-design-1ffaf46226f0">
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Neumorphism UI/UX Design.</h3>
                            </a>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">8K+</div>
                    </div>
                    
                </div>
                <div Class="project-div blog-div">
                    <div className="project-img blog-img">
                        <img src={project2} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                        <a href="https://uxplanet.org/my-portfolio-website-helps-me-to-get-a-full-stack-internship-32c2f70d8a8f">
                            <h3 className="des-head blog-head">My Portfolio Website Helps Me To Get A Full Stack Internship.</h3>
                            </a>
                            <p className="blog-para">3 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                
                <div className="project-div blog-div">
                    <div className="project-img blog-img">
                        <img src={project3} className="blogimg" />
                    </div>
                    <div className="project-des blog-des">
                        <div>
                        <a href="https://uxplanet.org/now-you-can-build-your-portfolio-in-glassmorphism-ui-ux-design-848599c74094">
                            <h3 className="des-head blog-head">Now You Can Build Your Portfolio in Glassmorphism UI/UX Design.</h3>
                            </a>
                            <p className="blog-para">5 min Read</p>
                        </div>
                        <div className="blog-views">4K+</div>
                    </div>
                </div>
            
                    <div Class="project-div blog-div">
                        <div className="project-img blog-img">
                            <img src={project4} className="blogimg" />
                        </div>
                        <div className="project-des blog-des">
                            <div>
                            <a href="https://uxplanet.org/5-best-landing-pages-that-anyone-can-create-254ce1f9c91c">
                                <h3 className="des-head blog-head">5 Best Landing Pages that Anyone Can Create.</h3>
                                </a>
                                <p className="blog-para">3 min Read</p>
                            </div>
                            <div className="blog-views">2K+</div>
                        </div>
                    </div>
            </div>
            <div className="social-footer">
                <a href="https://medium.com/@vikalpkaushik99"><button className="social-btn">More Blogs 📝</button></a>
            </div>
            </div>
            )}
        </div>
    )
}